import Vue from 'vue';
import VvsControlWrapper from '@/components/controls/VvsControlWrapper';
import VvsInput from '@/components/controls/VvsInput';
import VvsTextarea from '@/components/controls/VvsTextarea';
import VvsSelect from '@/components/controls/VvsSelect';
import VvsCheckbox from '@/components/controls/VvsCheckbox';
import VvsGeneralCheckbox from '@/components/controls/VvsGeneralCheckbox';
import VvsRadio from '@/components/controls/VvsRadio';
import VvsAddress from '@/components/others/VvsAddress';
import VvsQuestions from '@/components/others/VvsQuestions';
import VvsUploader from '@/components/others/VvsUploader';
import VvsRecaptcha from '@/components/others/VvsRecaptcha';
import VvsSubmitButton from '@/components/others/VvsSubmitButton';

Vue.component('VvsControlWrapper', VvsControlWrapper);
Vue.component('VvsInput', VvsInput);
Vue.component('VvsTextarea', VvsTextarea);
Vue.component('VvsSelect', VvsSelect);
Vue.component('VvsCheckbox', VvsCheckbox);
Vue.component('VvsGeneralCheckbox', VvsGeneralCheckbox);
Vue.component('VvsRadio', VvsRadio);
Vue.component('VvsQuestions', VvsQuestions);
Vue.component('VvsAddress', VvsAddress);
Vue.component('VvsUploader', VvsUploader);
Vue.component('VvsRecaptcha', VvsRecaptcha);
Vue.component('VvsSubmitButton', VvsSubmitButton);
